import { Box } from "@primer/react";
import PreviewableAvatar from "../hocsinh-avatar-preview/PreviewableAvatar";

interface IHocSinhShortInfoWithClassProps {
  data: any;
  onClick?: (data: any) => void;
}

const HocSinhShortInfoWithClass = (props: IHocSinhShortInfoWithClassProps) => {
  const { data, onClick } = props;

  const handleClick = () => {
    if (onClick) {
      onClick(data);
    }
  };

  return (
    <Box
      sx={{ display: "flex", cursor: onClick ? "pointer" : "default" }}
      onClick={handleClick}
    >
      <Box sx={{ mr: 2, mt: 1 }}>
        <PreviewableAvatar
          avatarUrl={data.avatar}
          fullName={data.ho_ten}
          size="large"
        />
      </Box>
      <Box sx={{ display: "grid", flex: 1 }}>
        <Box
          sx={{
            fontWeight: 600,
            color: onClick ? "#133E87" : "inherit",
            "&:hover": onClick ? { textDecoration: "underline" } : {},
          }}
        >
          {data.ho_ten}
        </Box>
        <Box sx={{ color: "fg.muted" }}>
          {data.ma_hs} - {data.ten_lop}
        </Box>
      </Box>
    </Box>
  );
};

export default HocSinhShortInfoWithClass;
